import React, { useEffect, useState } from "react";
import { api } from "./../../Api/api";

import PaginatedItems from "../Paginacao/Paginacao";

import "./Styles.css";

const ModalPeriodo = ({ close, visible, values }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [listaStyleded, setListaStylede] = useState([]);
  const [load, setLoad] = useState(true);
  const [itemOffset, setItemOffset] = useState(0);
  const [totalAlerts, setTotalAlerts] = useState(0);

  const closePopup = () => {
    setItemOffset(0)
    close()
  }

  useEffect(() => {
    setModalVisible(visible);

    if (visible) {
      async function consultar() {
        try {
          let string = "";

          Object.keys(values).forEach((item, index) => {
            if (index === 0) {
              string += `?${item}=${values[item]}`;
            } else {
              string += `&${item}=${values[item]}`;
            }
          });

          string += `&resultOffset=${itemOffset}&resultRecordCount=10`

          const responseAlerts = (await api.get(`/alertas/periodo${string}`)).data;
          const alerts = responseAlerts.features
          setTotalAlerts(responseAlerts.totalCount)

          let lista = [];
          if (alerts.length > 0) {
            let infos = (await api.get(`/alertas/info`)).data;

            const domains = {};
            infos.fields.forEach((field) => {
              if (field.domain) {
                domains[field.name] = {};
                field.domain.codedValues.forEach((value) => {
                  domains[field.name][value.code] = value.name;
                });
              }
            });

            const getValueDomain = (field, value) => domains[field][value];

            for (let i = 0; i < alerts.length; i++) {
              alerts[i].attributes.uf = values.estado;
              alerts[i].attributes.servicos_afetados = alerts[i].attributes
                .tipo_de_rede
                ? getValueDomain(
                    "tipo_de_rede",
                    alerts[i].attributes.tipo_de_rede
                  )
                : "";
              alerts[i].attributes.causa_interrupcao = alerts[i].attributes
                .motivo_interrupcao
                ? getValueDomain(
                    "motivo_interrupcao",
                    alerts[i].attributes.motivo_interrupcao
                  )
                : "";
              alerts[i].attributes.solucao_aplicada = alerts[i].attributes
                .providencia_normalizacao
                ? getValueDomain(
                    "providencia_normalizacao",
                    alerts[i].attributes.providencia_normalizacao
                  )
                : "";
            }

            lista = alerts.map((x) => x.attributes);

          }

          setListaStylede(lista);
          if (itemOffset === 0){
            window.scrollTo({ top: 0, behavior: "smooth" });
          }

        } catch (error) {
          console.log(error);
        } finally {
          setLoad(false);
        }
      }
      consultar();
    }
  }, [visible, itemOffset]);

  return (
    <React.Fragment>
      {!modalVisible ? null : (
        <div id="modal-periodo" className="modal-periodo">
          {load ? (
            <div className="load">
              <div className="lds-ripple">
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            <div className="modal-conteudo">
              <div className="container-topo">
                <div className="close" onClick={closePopup}></div>
                <span className="titulo-modal">
                  Veja abaixo as interrupções de rede que podem ter afetado o
                  serviço em sua região.
                </span>
              </div>
              <PaginatedItems
                itemsPerPage={10}
                lista={listaStyleded}
                style={"paginacao"}
                totalLista={totalAlerts}
                itemOffset={itemOffset}
                setItemOffset={setItemOffset}
              />
              <div className="container-nova-consulta">
                <span className="info">
                  A TIM preza pela transparência com seus clientes e
                  disponibiliza as informações acima, reforçando o disposto no
                  Regulamento do Serviço Móvel Pessoal, aprovado pela Resolução
                  da ANATEL n 477/07 e no Regulamento do Serviço Telefônico Fixo
                  Comutado, aprovado pela Resolução n 426/06.
                </span>
                <button className="button-nova-consulta" onClick={closePopup}>
                  Nova Consulta
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default ModalPeriodo;
